var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPortfolioIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2400_8723)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.99984 1.66699C5.39984 1.66699 1.6665 5.40033 1.6665 10.0003C1.6665 14.6003 5.39984 18.3337 9.99984 18.3337C14.5998 18.3337 18.3332 14.6003 18.3332 10.0003C18.3332 5.40033 14.5998 1.66699 9.99984 1.66699ZM9.99984 16.667C6.32484 16.667 3.33317 13.6753 3.33317 10.0003C3.33317 6.32533 6.32484 3.33366 9.99984 3.33366C13.6748 3.33366 16.6665 6.32533 16.6665 10.0003C16.6665 13.6753 13.6748 16.667 9.99984 16.667ZM10.2582 9.28366C8.78317 8.90866 8.30817 8.50033 8.30817 7.89199C8.30817 7.19199 8.9665 6.70033 10.0582 6.70033C11.2082 6.70033 11.6415 7.25033 11.6748 8.06699H13.0998C13.0582 6.95033 12.3748 5.92533 11.0248 5.59199V4.16699H9.08317V5.57533C7.82484 5.84199 6.8165 6.65866 6.8165 7.91699C6.8165 9.40866 8.05817 10.1587 9.8665 10.592C11.4915 10.9753 11.8165 11.5503 11.8165 12.1503C11.8165 12.592 11.4915 13.3087 10.0665 13.3087C8.73317 13.3087 8.20817 12.7087 8.13317 11.942H6.69984C6.78317 13.3587 7.83317 14.1587 9.08317 14.417V15.8337H11.0332V14.442C12.2998 14.2003 13.2998 13.4753 13.3082 12.1337C13.2998 10.3003 11.7248 9.66699 10.2582 9.28366Z",
    fill: "#707070"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2400_8723"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPortfolioIcon);
export default __webpack_public_path__ + "static/media/portfolioIcon.4c04cbf3e475d416c8d6eb3c7786c53f.svg";
export { ForwardRef as ReactComponent };